<template>
  <section>
    <v-footer app class="pt-3">
      <v-btn x-large @click.prevent="regresar" class="mr-5"
        ><v-icon>chevron_left</v-icon> Regresar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        x-large
        @click.prevent="descartar"
        v-if="!soloLectura && citaID"
        class="mr-5"
        ><v-icon>close</v-icon> Descartar Cambios
      </v-btn>
      <v-btn
        color="primary"
        x-large
        @click.prevent="guardar"
        v-if="!soloLectura"
        ><v-icon>save</v-icon> Guardar
      </v-btn>
      <v-btn
        color="primary"
        v-else-if="!muestraTomada"
        x-large
        @click.native="soloLectura = false"
      >
        <v-icon>edit</v-icon> Editar
      </v-btn>
    </v-footer>
    <v-form ref="formCita">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card style="height: 100%">
            <v-card-title class="text-h4 primary--text">
              Datos de la Cita
            </v-card-title>
            <v-card-text grid-list-md>
              <v-layout row wrap class="ma-1">
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Tipo de Cita:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-autocomplete
                    :readonly="soloLectura"
                    :rules="[() => !!cita.AgendaTipoID || 'Campo requerido']"
                    hide-details="auto"
                    :items="catalogos.AgendaTipos"
                    item-text="Agenda"
                    item-value="AgendaTipoID"
                    v-model="cita.AgendaTipoID"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Tipos de Análisis
                </v-flex>
                <v-flex xs12 md9 class="pr-5" row>
                  <v-checkbox
                    :readonly="soloLectura"
                    :rules="[
                      () =>
                        !!cita.AnalisisPCR ||
                        cita.AnalisisAntigenos ||
                        cita.AnalisisAnticuerpos ||
                        'Campo requerido',
                    ]"
                    label="PCR"
                    v-model="cita.AnalisisPCR"
                  />
                  <v-checkbox
                    :readonly="soloLectura"
                    :rules="[
                      () =>
                        !!cita.AnalisisPCR ||
                        cita.AnalisisAntigenos ||
                        cita.AnalisisAnticuerpos ||
                        'Campo requerido',
                    ]"
                    class="ml-3"
                    label="Antígenos"
                    v-model="cita.AnalisisAntigenos"
                  />
                  <v-checkbox
                    :readonly="soloLectura"
                    :rules="[
                      () =>
                        !!cita.AnalisisPCR ||
                        cita.AnalisisAntigenos ||
                        cita.AnalisisAnticuerpos ||
                        'Campo requerido',
                    ]"
                    class="ml-3"
                    label="Anticuerpos"
                    v-model="cita.AnalisisAnticuerpos"
                  />
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Fecha
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <datepicker2
                    :min="this.hoy"
                    :editando="!!citaID || esDuplicacion"
                    :readonly="soloLectura"
                    :rules="[() => !!cita.FechaMuestra || 'Campo requerido']"
                    v-model="cita.FechaMuestra"
                  ></datepicker2>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Hora
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <timepicker2
                    :readonly="soloLectura"
                    :rules="[() => !!cita.HoraMuestra || 'Campo requerido']"
                    v-model="cita.HoraMuestra"
                    :allowed-minutes="(m) => m % 5 === 0"
                  ></timepicker2>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Responsable de Muestra
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-autocomplete
                    :readonly="soloLectura"
                    :rules="[() => !!cita.Enfermera || 'Campo requerido']"
                    hide-details="auto"
                    :items="catalogos.Enfermeras"
                    item-text="Nombre"
                    return-object
                    v-model="cita.Enfermera"
                    :append-outer-icon="'date_range'"
                    @click:append-outer="abrirCalendario"
                  >
                  </v-autocomplete>
                </v-flex>
                <!-- SE CAMBIO POR MULTIPLE -->
                <template
                  v-if="
                    false && cita.AgendaTipoID !== 2 && cita.AgendaTipoID !== 4
                  "
                >
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Nombre(s):
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[
                        () => !!personas[0].Nombres || 'Campo requerido',
                      ]"
                      v-model="personas[0].Nombres"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Primer Apellido:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[
                        () => !!personas[0].PrimerApellido || 'Campo requerido',
                      ]"
                      v-model="personas[0].PrimerApellido"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Segundo Apellido:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[
                        () =>
                          !!personas[0].SegundoApellido || 'Campo requerido',
                      ]"
                      v-model="personas[0].SegundoApellido"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Teléfono Celular
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[
                        () =>
                          !personas[0].Telefono_Celular ||
                          personas[0].Telefono_Celular.length === 10 ||
                          'Ingrese teléfono 10 dígitos',
                      ]"
                      v-model="personas[0].Telefono_Celular"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Número de pacientes:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[() => !!NumeroPacientes || 'Campo requerido']"
                      type="number"
                      v-model="NumeroPacientes"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                </template>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Correo de confirmación de cita o personal
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    :rules="[
                      () =>
                        validarEmail(cita.CorreoCita) ||
                        'Ingrese un correo válido',
                    ]"
                    v-model="cita.CorreoCita"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="text-h5 pt-4 pl-5">
                  Forma de pago
                </v-flex>
                <v-flex xs12
                  ><v-radio-group
                    :readonly="soloLectura"
                    :rules="[() => cita.PagoTipoID !== -1 || 'Campo requerido']"
                    v-model="cita.PagoTipoID"
                  >
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        md4
                        v-for="tp in catalogos.PagosTipos"
                        :key="tp.PagoTipoID"
                      >
                        <v-radio
                          :label="tp.Pago"
                          :value="tp.PagoTipoID"
                        ></v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </v-flex>
                <template v-if="cita.PagoTipoID === 5">
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Convenio
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      v-model="cita.ConvenioNombre"
                      :rules="[
                        () => !!cita.ConvenioNombre || 'Campo requerido',
                      ]"
                    ></v-text-field>
                  </v-flex>
                </template>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Observaciones Interno:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-textarea
                    :rows="4"
                    v-model="cita.ObservacionesInterno"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          md6
          v-if="cita.AgendaTipoID === 3 || cita.AgendaTipoID === 4"
        >
          <v-card style="height: 100%">
            <v-card-title class="text-h4 primary--text">
              Datos de Visita Domicilio
            </v-card-title>
            <v-card-text grid-list-md>
              <v-layout row wrap class="ma-1">
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Calle:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    :rules="[() => !!cita.Calle || 'Campo requerido']"
                    v-model="cita.Calle"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Número Exterior:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    :rules="[() => !!cita.NumeroExterior || 'Campo requerido']"
                    v-model="cita.NumeroExterior"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Número Interior:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    v-model="cita.NumeroInterior"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Colonia:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    :rules="[() => !!cita.Colonia || 'Campo requerido']"
                    v-model="cita.Colonia"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Referencias:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    v-model="cita.Referencias"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Alcaldía / Municipio:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    :rules="[
                      () => !!cita.DelegacionMunicipio || 'Campo requerido',
                    ]"
                    v-model="cita.DelegacionMunicipio"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  CP:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    type="number"
                    hide-details="auto"
                    :rules="[() => !!cita.CodigoPostal || 'Campo requerido']"
                    v-model="cita.CodigoPostal"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          :class="{ md6: cita.AgendaTipoID === 1 || cita.AgendaTipoID === 2 }"
          v-if="NumeroPacientes && personas.length >= NumeroPacientes"
        >
          <v-card style="height: 100%">
            <v-card-title class="text-h4 primary--text">
              Datos de pacientes
            </v-card-title>
            <v-card-text grid-list-md>
              <v-layout
                row
                wrap
                class="ma-1"
                v-for="i in NumeroPacientes ? parseInt(NumeroPacientes) : 0"
                :key="i"
              >
                <v-flex xs12 class="text-h5 pt-4 pl-5">
                  Paciente {{ i }}
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="personas[i - 1].Nombres"
                    hide-details="auto"
                    outlined
                    label="Nombre(s)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="personas[i - 1].PrimerApellido"
                    hide-details="auto"
                    outlined
                    label="Primer Apellido"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="personas[i - 1].SegundoApellido"
                    hide-details="auto"
                    outlined
                    label="Segundo Apellido"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="personas[i - 1].Telefono_Celular"
                    hide-details="auto"
                    outlined
                    label="Celular"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <calendario-enfermeras
      @cerrar="cerrarCalendario"
      v-if="mostrarCalendario"
    ></calendario-enfermeras>
  </section>
</template>

<script>
import datepicker2 from "../../components/DatePicker2";
import timepicker2 from "../../components/TimePicker2";
import ServicioCatalogos from "../../services/catalogos.js";
import ServicioCitas from "../../services/citas.js";
import CalendarioEnfermeras from "./CalendarioEnfermeras.vue";

export default {
  name: "NuevaCita",
  components: { datepicker2, timepicker2, CalendarioEnfermeras },
  data() {
    return {
      NumeroPacientes: 1,
      cita: { AgendaTipoID: 1, PagoTipo: -1 },
      muestraTomada: false,
      catalogos: {
        Empresas: [],
        PagosTipos: [],
        Enfermeras: [],
        AgendaTipos: [],
      },
      personas: [{}],
      soloLectura: false,
      citaID: 0,
      datosOriginales: null,
      mostrarCalendario: false,
      esDuplicacion: false,
    };
  },
  methods: {
    cerrarCalendario() {
      this.mostrarCalendario = false;
    },
    abrirCalendario() {
      this.mostrarCalendario = true;
    },
    regresar() {
      this.$router.back();
    },
    async cargarCatalogos() {
      let res = await ServicioCatalogos.getEmpresas();
      this.catalogos.Empresas = res.data.data.Table0;
      res = await ServicioCatalogos.getPagosTipos();
      this.catalogos.PagosTipos = res.data.data.Table0;
      res = await ServicioCatalogos.getEnfermeras();
      this.catalogos.Enfermeras = res.data.data.Table0;
      res = await ServicioCatalogos.getAgendaTipos();
      this.catalogos.AgendaTipos = res.data.data.Table0;
    },
    async guardar() {
      if (this.$refs.formCita.validate()) {
        let personas = [];
        for (let i = 0; i <= this.NumeroPacientes - 1; i++) {
          personas.push(this.personas[i]);
        }
        const cita = {
          CitaID: this.citaID,
          AgendaTipoID: this.cita.AgendaTipoID,
          ConvenioNombre: this.cita.ConvenioNombre,
          PagoTipoID: this.cita.PagoTipoID,
          CorreoCita: this.cita.CorreoCita,
          DelegacionMunicipio: this.cita.DelegacionMunicipio,
          Colonia: this.cita.Colonia,
          CodigoPostal: this.cita.CodigoPostal,
          Calle: this.cita.Calle,
          NumeroInterior: this.cita.NumeroInterior,
          NumeroExterior: this.cita.NumeroExterior,
          Referencias: this.cita.Referencias,
          FechaMuestra: `${this.cita.FechaMuestra}T${this.cita.HoraMuestra}:00`,
          Personas: personas,
          Enfermera_UsuarioID: this.cita.Enfermera
            ? this.cita.Enfermera.Enfermera_UsuarioID
            : null,
          AnalisisPCR: !!this.cita.AnalisisPCR,
          AnalisisAntigenos: !!this.cita.AnalisisAntigenos,
          AnalisisAnticuerpos: !!this.cita.AnalisisAnticuerpos,
          ObservacionesInterno: this.cita.ObservacionesInterno,
        };
        const resCita = this.citaID
          ? await ServicioCitas.actualizarCita(cita)
          : await ServicioCitas.crearCita(cita);
        if (resCita.data.result === 1) {
          this.$root.mensajeExito = "La cita se guardó exitosamente";
          this.$router.back();
        } else {
          this.$root.mensajeError =
            resCita.data.mensaje || "Error al guardar la cita.";
        }
      } else {
        this.$root.mensajeError =
          "Por favor llene todos los campos obligatorios";
      }
    },
    descartar() {
      this.cita = { ...this.datosOriginales.cita };
      for (let i = 0; i < this.datosOriginales.personas.length; i++) {
        this.$set(
          this.personas[i],
          "Nombres",
          this.datosOriginales.personas[i].Nombres
        );
        this.$set(
          this.personas[i],
          "PrimerApellido",
          this.datosOriginales.personas[i].PrimerApellido
        );
        this.$set(
          this.personas[i],
          "SegundoApellido",
          this.datosOriginales.personas[i].SegundoApellido
        );
        this.$set(
          this.personas[i],
          "Telefono_Celular",
          this.datosOriginales.personas[i].Telefono_Celular
        );
      }
      this.soloLectura = true;
    },
  },
  async mounted() {
    await this.cargarCatalogos();
    this.cita.AgendaTipoID = this.catalogos.AgendaTipos[0].AgendaTipoID;
    const citaID = this.$route.params.citaId;
    const citaDuplicarID = this.$route.params.citaDuplicarId;
    this.esDuplicacion = !!citaDuplicarID;
    if (citaID || citaDuplicarID) {
      const citaid = citaID ? citaID : citaDuplicarID;
      const resCita = await ServicioCitas.getCita(citaid);
      const cita = resCita.data.data.Table0[0];
      const personas = resCita.data.data.Table1;
      this.NumeroPacientes = personas.length;
      let res = {
        ...this.cita,
        ...cita,
      };
      const esEmpresa = !!cita.ConvenioNombre;
      res = {
        ...res,
        FechaMuestra: cita.FechaMuestra.split("T")[0],
        HoraMuestra: cita.FechaMuestra.split("T")[1].slice(0, 5),
        CorreoCita: cita.CorreoCita,
        PagoTipoID: cita.PagoTipoID,
        ObservacionesInterno: cita.ObservacionesInterno,
        Enfermera: citaDuplicarID
          ? null
          : this.catalogos.Enfermeras.find(
              (enf) => enf.Enfermera_UsuarioID === cita.Enfermera_UsuarioID
            ),
      };
      this.personas = personas;
      this.cita = res;
      if (citaID) {
        this.datosOriginales = {
          cita: { ...res },
          personas: personas,
        };
        this.soloLectura = true;
        this.citaID = citaID;
        this.muestraTomada = personas.some((persona) => !!persona.MuestraID);
      } else {
        res.CitaID = null;
      }
    }
  },
  watch: {
    NumeroPacientes() {
      while (
        this.NumeroPacientes &&
        this.NumeroPacientes >= this.personas.length - 1
      ) {
        this.personas.push({});
      }
    },
  },
};
</script>
